import { FlexDiv, GenericDiv } from 'commonStyles';
import styled, { css, keyframes } from 'styled-components';

export const PageContainer = styled(GenericDiv)`
	background-color: #fff;
	p{
		margin-bottom: 10px;
	}
`;

export const DocumentContainer = styled(GenericDiv)`
	max-height: 80vh;
	overflow-y: scroll;
	background-color: #727272;
	position: relative;
	.closebtn{
		position: sticky;
		display: block;
		top: 0;
		left: 20px;
	}
	&::after{
		content: '';
		position: sticky;
		display: block;
		bottom: 0;
		background-color: #727272;
		box-shadow: 0 -5px 4px rgba(0,0,0,0.3);
		left: 0;
		height: 50px;
		width: 100%;
	}
	&::before{
		content: '';
		position: sticky;
		display: block;
		top: 0;
		background-color: #727272;
		box-shadow: 0 4px 4px rgba(0,0,0,0.3);
		left: 0;
		height: 30px;
		width: 100%;
	}
`;

export const MainWrapper = styled(FlexDiv)`
	max-width: 1200px;
	margin: 30px auto;
`;
